import './TabNavigation.scss';
import React, { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';

export class TabNavigation extends PureComponent {

  state = {
    activeTabIndex: 0
  }

  componentDidMount = () => {
    this.setState({
      activeTabIndex: this.findDefaultTab()
    });
  }

  findDefaultTab = () => {
    const { defaultTab, navConfig } = this.props;
    return _.findIndex(navConfig, o => o.path.includes(defaultTab));
  }

  handleUpdateActiveTab = (index) => {
    this.setState({ activeTabIndex: index });
  }

  render() {
    const { navConfig } = this.props;

    return (
      <div className="tabs-wrapper">
        <nav className="tab-navigation">
          <div className="tab-navigation-menu">
            <div className={`link-container active-${this.state.activeTabIndex}`}>
              {navConfig.map((item, index) => (
                <NavLink key={index} to={item.path} target={item.target} onClick={()=> this.handleUpdateActiveTab(index)} activeClassName="active">
                  {item.name}
                  <span className="bottom-border" />
                </NavLink>
              ))}
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default TabNavigation;



// WEBPACK FOOTER //
// ./src/components/TabNavigation/TabNavigation.jsx